import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/auth")({
  head: () =>
    buildHead({
      title: "Sign in to LohaLink — Verified scrap metal marketplace",
      description:
        "Sign in or create a buyer/seller account on LohaLink. Both GST-registered and unregistered businesses welcome.",
      canonical: "/auth",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/Auth")),
});
